export const CHECKOUT_MESSAGES = {
  pageTitle: 'Finalizar Compra',
  loginSection: {
    title: 'Quase lá! Entre ou crie sua conta',
    description:
      'Seus dados de pagamento já estão preenchidos. Faça login ou crie uma conta para concluir a compra.',
  },
  identity: {
    title: 'Identificação para finalizar',
    description: 'Informe seu email para vincular esta compra sem sair desta página.',
    emailLabel: 'Email',
    emailPlaceholder: 'voce@exemplo.com',
    continueButton: 'Continuar',
    validatingButton: 'Validando...',
    checkingEmailButton: 'Verificando email...',
    resolveError: 'Não foi possível validar seu email no momento. Tente novamente.',
    resolveSuccess: 'Email validado. Você já pode concluir o pagamento.',
    checkEmailError: 'Não foi possível verificar o email no momento. Tente novamente.',
    newUserPrompt: 'Não encontramos cadastro para este email. Confirme o email para continuar.',
    confirmEmailLabel: 'Confirmar email',
    confirmEmailPlaceholder: 'repita seu email',
    confirmEmailMismatch: 'Os emails informados não coincidem.',
    passwordSwitch: 'Quero definir uma senha agora (opcional)',
    passwordLabel: 'Senha',
    confirmPasswordLabel: 'Confirmar senha',
    passwordMismatch: 'As senhas não coincidem.',
  },
  success: {
    existingUser: 'Entrar na conta',
    newUserWithPassword: 'Entrar agora',
    newUserPasswordPending: 'Definir senha',
  },
  validation: {
    invalidDocument: 'Informe um CPF ou CNPJ válido.',
  },
};
